import './SplashScreen.less';
import React from 'react';
import Logo from "../../widgets/logo/Logo";


export default function SplashScreen() {

    return <div className="splash-screen">
        <Logo/>
    </div>;
}
